export type EntityScope = 'inventory' | 'lead' | 'invoice' | 'client' | 'transport' | 'goto'

export interface ParsedSlashQuery {
  raw: string
  isSlash: boolean
  token: string
  query: string
  scope: EntityScope | null
  commandsOnly: boolean
}

const SCOPE_ALIASES: Record<string, EntityScope> = {
  inventory: 'inventory',
  truck: 'inventory',
  trucks: 'inventory',
  lead: 'lead',
  leads: 'lead',
  invoice: 'invoice',
  invoices: 'invoice',
  client: 'client',
  clients: 'client',
  transport: 'transport',
  transporter: 'transport',
  goto: 'goto',
  page: 'goto',
}

export function parseSlashQuery(input: string): ParsedSlashQuery {
  if (!input.startsWith('/')) {
    return {
      raw: input,
      isSlash: false,
      token: '',
      query: input.trim(),
      scope: null,
      commandsOnly: false,
    }
  }

  const rest = input.slice(1)
  if (!rest || rest.startsWith(' ')) {
    return {
      raw: input,
      isSlash: true,
      token: '',
      query: rest.trim(),
      scope: null,
      commandsOnly: true,
    }
  }

  const space = rest.indexOf(' ')
  const token = (space === -1 ? rest : rest.slice(0, space)).toLowerCase()
  const query = space === -1 ? '' : rest.slice(space + 1).trim()
  const scope = SCOPE_ALIASES[token] ?? null

  if (scope) {
    return {
      raw: input,
      isSlash: true,
      token,
      query,
      scope,
      commandsOnly: false,
    }
  }

  return {
    raw: input,
    isSlash: true,
    token,
    query,
    scope: null,
    commandsOnly: true,
  }
}
